import {ButtonChooseTemplate as _ButtonChooseTemplate} from '@/biz/ai'
import {ButtonImportModel as _ButtonImportModel} from '@/biz/ai/chat'

export default function ButtonChooseTemplate({promptTemplateCode, ...props}) {
    return (
        <_ButtonChooseTemplate
            extra={{promptTemplateCode}}
            {...props}
        />
    )
}
